import { render } from "./RoomLower.vue?vue&type=template&id=5be6aa2c&scoped=true"
import script from "./RoomLower.vue?vue&type=script&lang=js"
export * from "./RoomLower.vue?vue&type=script&lang=js"

import "./RoomLower.vue?vue&type=style&index=0&id=5be6aa2c&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be6aa2c"]])

export default __exports__